import { Box, Flex } from '@mantine/core';
import { RevisionPlanRow } from 'components/tables/data/revision-plan/types';
import DeviceTypeIcon from 'components/device/DeviceTypeIcon';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the device type.
 */
export default function DeviceTypeColumn({ data: { deviceType } }: { data: RevisionPlanRow }) {
  return (
    <Flex gap={8}>
      <Box w={24} h={24}>
        <DeviceTypeIcon typeId={deviceType.deviceTypeId} />
      </Box>
      <P2Regular color="gray.8">{deviceType.deviceTypeName}</P2Regular>
    </Flex>
  );
}
